

import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import ApiService from "../../../network/ApiService";
import { useSelector } from "react-redux";

function Gallery() {
  const { fetchGalleries } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const languageStatus = sessionStorage.getItem("language") || "en";

  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [lightboxTitle, setLightboxTitle] = useState("");

  const getPhotoCountText = (count) => {
    if (languageStatus === "en") {
      if (count === 1) return "1 photo available";
      return `${count} photos available`;
    } else {
      // Nepali example, change if needed
      if (count === 1) return "१ फोटो उपलब्ध छ";
      return `${count} फोटोहरू उपलब्ध छन्`;
    }
  };

  // Fetch gallery from backend
  const fetchGalleryImages = async () => {
    try {
      const response = await fetchGalleries();
      setGalleryData(response.data.messageWithImg || []);
    } catch (error) {
      console.log(error.message);
    }
  };
  // Show images in Lightbox
  const handleViewSlides = (galleryUrls, title, clickedIndex = 0) => {
    const images =
      galleryUrls && galleryUrls.length > 0
        ? galleryUrls.map((img) => ({
            src: img,
            alt: "image",
            width: 3840,
            height: 2560,
          }))
        : [];

    setSlides(images);
    setPhotoIndex(clickedIndex);
    setLightboxTitle(title);
    setOpen(true);
  };
//   console.log('checking',galleryData);

  useEffect(() => {
    if (organizationId) {
      fetchGalleryImages();
    }
  }, [organizationId]);

  return (
    <>
      <div style={{ padding: "40px 0", backgroundColor: "#f5fdf7" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 15px" }}>
          <h2
            style={{
              textAlign: "center",
              marginBottom: "40px",
              fontSize: "2rem",
              color: '#0f2495',
              fontWeight: "bold",
              borderBottom: '2px solid #0f2495',
              display: "inline-block",
            }}
          >
            {languageStatus === "en" ? "Photo Gallery" : "फोटो ग्यालरी"}
          </h2>

          {galleryData.length > 0 ? (
            <div
              className="uk-grid"
              uk-grid="true"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              {galleryData.map((data, index) => {
                const imageUrl =
                  data?.imageUrl && data.imageUrl !== "n/a"
                    ? data.imageUrl
                    : "/assets/images/image.jpg"; // fallback image

                const title =
                  languageStatus === "en"
                    ? data.header ?? data.headerNp
                    : data.headerNp ?? data.header;

                const photoCount = data?.galleryUrls?.length || 0;

                return (
                  <button
                    key={index}
                    type="button"
                    onClick={() => handleViewSlides(data.galleryUrls, title, 0)}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      padding: 0,
                      textAlign: "left",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.2s",
                      userSelect: "none",
                      width: "100%",
                    }}
                    aria-label={`${title}, ${getPhotoCountText(
                      photoCount
                    )}, click to view`}
                  >
                    <div style={{ width: "100%", height: "200px", overflow: "hidden" }}>
                      <img
                        src={imageUrl}
                        alt={title}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                          filter: "none",
                        }}
                      />
                    </div>
                    <div style={{ padding: "15px" }}>
                      <h4
                        style={{
                          margin: "0 0 5px 0",
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "blue",
                        }}
                      >
                        {title}
                      </h4>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "14px",
                          color: "blue",
                        }}
                      >
                        {getPhotoCountText(photoCount)}
                      </p>
                    </div>
                  </button>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "20px",
                backgroundColor: "#fff3f3",
                color: "#d9534f",
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              {languageStatus === "en"
                ? "Photo Gallery Not Found"
                : "फोटो ग्यालरी भेटिएन"}
            </div>
          )}
        </div>
      </div>

      {/* Lightbox Viewer */}
      {open && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={photoIndex}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
          render={{
            slideHeader: () => (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "20px",
                  color:'#0f2495',
                  paddingTop: "10px",
                }}
              >
                {lightboxTitle}
              </div>
            ),
          }}
        />
      )}
    </>
  );
}

export default Gallery;
